// @flow
import React, { Component, type ComponentType } from "react";
import RandomColor from "random-material-color";

import { hexToRgbA } from "../../../utils/color";
import { getThumb } from "../../../utils/image";
import { Outer } from "./styled";

type Props = {|
    images: ComponentType<any>,
    index: Number,
    onShowPhoto: Function
|};

class Photo extends Component<Props> {
    render() {
        const { images, index, onShowPhoto } = this.props;

        const image = images[index];
        const payload = { images, index };
        const backgroundColor = hexToRgbA(
            RandomColor.getColor({
                text: `${image.id}`
            }),
            0.05
        );

        return (
            <Outer
                style={{ backgroundImage: `url(${getThumb(image.url)})`, backgroundColor }}
                alt={image.title}
                onClick={() => onShowPhoto(payload)}
            />
        );
    }
}

export default Photo;



// WEBPACK FOOTER //
// ./src/blog-card/photos/photo/view.js